import React, { useEffect, useRef } from "react";
import { debounceTime, tap } from "rxjs";
import PropTypes from "prop-types";
import eventEmitter from "../../../../components/eventEmitter";

function DimensionsDetector({ onWidthChange, onHeightChange }) {
  const elRef = useRef(null);

  useEffect(() => {
    function update() {
      if (!elRef.current) return;
      const { width, height } = elRef.current.getBoundingClientRect();
      onWidthChange(width);
      onHeightChange(height);
    }

    const sub = eventEmitter.resizeTracker$
      .pipe(debounceTime(100), tap(update))
      .subscribe();

    update();

    return () => sub.unsubscribe();
  }, [onWidthChange, onHeightChange]);

  return <div className="tw-absolute tw-inset-0" ref={elRef} />;
}

DimensionsDetector.propTypes = {
  onWidthChange: PropTypes.func,
  onHeightChange: PropTypes.func,
};

DimensionsDetector.defaultProps = {
  onWidthChange: () => {},
  onHeightChange: () => {},
};

export default React.memo(DimensionsDetector);
